"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

var _column = _interopRequireDefault(require("./column/column.style"));

var _row = require("./row.config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledRow = _styledComponents.default.div`
  clear: both;
  position: relative;

  ${({
  gutter,
  columnDivide
}) => {
  const size = _row.ROW_SIZES_CSS[gutter];
  return (0, _styledComponents.css)`
      margin-bottom: -${size}px;
      margin-left: -${size}px;

      ${_column.default} {
        margin-bottom: ${size}px;
        padding-left: ${size}px;

        ${columnDivide && (0, _styledComponents.css)`
          position: relative;

          &:before {
            content: "";
            position: absolute;
            width: 1px;
            height: 100%;
            background-color: ${_base.default.palette.slateTint(70)};
            left: ${size / 2}px;
            top: 0;
          }

          &:first-child:before {
            display: none;
          }
        `}
      }
    `;
}}

  /* Clearfix */
  &:before,
  &:after {
    content: "";
    display: table;
  }
  &:after {
    clear: both;
  }
`;
var _default = StyledRow;
exports.default = _default;